import { createStyles, makeStyles } from "@material-ui/core";
import {
    CheckIcon,
    FeedbackButtons,
    PageActionButton,
    RelodeTheme,
    TimesIcon,
} from "@relode/core";
import { JobCandidateStatus } from "@relode/core/domain";
import * as React from "react";

import { useCandidateContext } from "../../../_infra";
import { CandidateActionsProps } from "./candidateActionsProps";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            actionButtonsContainer: {
                display: "flex",
                paddingTop: 0,
            },
            rejectButtonContainer: {
                display: "flex",
            },
            positiveActionButtonContainer: {},

            feedbackButtonContainer: {
                marginRight: theme.spacing(4),
            },
        }),
    {
        name: "CandidateActionsDesktop",
    }
);

export const CandidateActionsDesktop = (props: CandidateActionsProps) => {
    const classes = useStyles({});
    const {
        state: {
            data: { candidate },
        },
    } = useCandidateContext();
    const { actions } = candidate;

    const {
        feedbackDetails,
        onFeedbackClick,
        selectedVote,
        canViewReject,
        onRejectClick,
        canViewPositiveAction,
        onPositiveActionClick,
    } = props;

    return (
        <>
            <div className={classes.actionButtonsContainer}>
                {feedbackDetails.canGiveFeedback ||
                feedbackDetails.canViewFeedback ? (
                    <FeedbackButtons
                        onClick={onFeedbackClick}
                        selectedFeedbackType={selectedVote}
                        showFeedbackCounts={feedbackDetails.canViewFeedback}
                        upCount={feedbackDetails.upVotesCount}
                        downCount={feedbackDetails.downVotesCount}
                        className={classes.feedbackButtonContainer}
                    />
                ) : null}
                {canViewReject ? (
                    <span className={classes.rejectButtonContainer}>
                        <PageActionButton
                            id="rejectCandidateButton"
                            data-cy="rejectCandidate-button"
                            actionType="negative"
                            title={actions.negativeCandidateStatusActionName}
                            disabled={
                                candidate.status === JobCandidateStatus.Rejected
                            }
                            onClick={onRejectClick}
                        >
                            <TimesIcon />
                        </PageActionButton>
                    </span>
                ) : null}

                {canViewPositiveAction ? (
                    <span className={classes.positiveActionButtonContainer}>
                        <PageActionButton
                            id="positiveActionCandidateButton"
                            data-cy={`${actions.positiveCandidateStatusActionName}-button`}
                            actionType="positive"
                            title={actions.positiveCandidateStatusActionName}
                            onClick={() =>
                                onPositiveActionClick(
                                    actions.positiveCandidateStatusActionName
                                )
                            }
                        >
                            <CheckIcon />
                        </PageActionButton>
                    </span>
                ) : null}
            </div>
        </>
    );
};
